import { render, staticRenderFns } from "./OperationalScreen_EventQuadrant.vue?vue&type=template&id=963d73b8&scoped=true&"
import script from "./OperationalScreen_EventQuadrant.vue?vue&type=script&lang=js&"
export * from "./OperationalScreen_EventQuadrant.vue?vue&type=script&lang=js&"
import style0 from "./OperationalScreen_EventQuadrant.vue?vue&type=style&index=0&id=963d73b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963d73b8",
  null
  
)

export default component.exports